import { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { mixOther } from 'api/mixOther'


type Item = {
  name: string | number;
  id: string;
  images: string;
  title: string;
  content: string;
};

type About = {
  meta_title: string;
  meta_description: string;
  meta_keywords: string;
  list: Item[];
};

export default function GioiThieu() {

    const [about, setAbout] = useState<About | null>(null)

    useEffect(() => {
        const loadOther = async () => {
            const res = await mixOther("ssabout","vi")
             if (!res?.status || !res.data?.json) {
                return;
            }

            try {
                const parsed = JSON.parse(res.data.json);
                setAbout((prev) => ({ ...prev, ...parsed }));
            } catch (error) {
                console.error("Failed to parse setting JSON:", error);
            }
        };

        loadOther();
    }, [])
    return (
        <>
            <Helmet>
                <title>{about?.meta_title || 'Giới thiệu - Dược Tâm Hạnh'}</title>
                {about?.meta_description && <meta name="description" content={about.meta_description} />}
                {about?.meta_keywords && <meta name="keywords" content={about.meta_keywords} />}
            </Helmet>
            <div className="container mx-auto py-4 px-0 space-y-4">
                <div className="bg-gray-100 py-6 md:py-12">
                    <div className="max-w-6xl mx-auto px-4 space-y-6 md:space-y-16">

                        {/* Section 1 */}
                        {about?.list?.map(( item: Item, index:number ) => (

                            <div 
                                key={item.id}
                                className="grid md:grid-cols-2 gap-8 items-center">

                                {/* Image */}
                                <div
                                    className={`text-[16px] ${
                                        index % 2 === 0
                                        ? "order-2 md:order-1"
                                        : "order-2 md:order-2"
                                    }`}
                                >
                                    <img
                                        src={item.images}
                                        alt="team"
                                        className="w-full rounded"
                                    />
                                </div>

                                {/* Content */}
                                <div  
                                    className={`text-[16px] ${
                                        index % 2 === 0
                                        ? "order-2 md:order-2"
                                        : "order-2 md:order-1"
                                    }`}
                                >
                                    <h2 className="text-2xl md:text-3xl font-bold text-[var(--primary-color)] mb-4 text-center">
                                        { item.title}
                                    </h2>

                                    <p className="text-gray-700 leading-relaxed mb-3"  dangerouslySetInnerHTML={{ __html: item.content }}/>
                                </div>
                            </div>
                        ))}

                        

                    </div>
                </div>
            </div>
        </>
    )
}
